import styled from "styled-components";

export const HTMLCompSection = styled.div`
  * {
    color: ${(p) => p.theme.COLORS.textw} !important;
  }
`;
